import { PasswordRecoverController } from './password-recover.controller';

export const PasswordRecoverComponent: ng.IComponentOptions = {
    template: require('./password-recover.html'),
    controller: PasswordRecoverController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/password-recover/password-recover.component.ts